import { Grid } from "@material-ui/core";
import classes from './index.module.scss';

const MenuImage = () => (
  <Grid container className={classes.image} />
);

MenuImage.className = classes.exportedMenuImageClass;

export default MenuImage;